/**
 * Created by jonas on 2023-02-13.
 */
import {gsap} from "gsap";
import {BS2} from "../../BS2";
import {BS2GameAssets} from "../../BS2GameAssets";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {BS2Sound} from "../../config/sound/BS2Sound";
import {LevelBar} from "./LevelBar";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {BS2Statics} from "../../config/BS2Statics";
import {BS2GameMode} from "../../server/BS2GameMode";

export class RitualCollectorBar extends PIXI.Container {
    private _levelThresholds: number[];
    private _maxThreshold: number;
    private _currentLevel: number;
    private _currentTotalValue: number;
    private _currentLevelValue: number;
    private _sigillSpines: PIXI.spine.Spine[];
    private _sigillBarContainer: PIXI.Container;
    private _dynamicContainer: PIXI.Container;
    private _levelBar: LevelBar;
    private _countUpAnim: gsap.core.Timeline | undefined;
    private _currentScatterAddAnimation: gsap.core.Timeline | undefined;
    private _selectedBoostedBet: string|undefined;
    private _wasXbet1Selected:boolean=false;
    private _restoreSoundDone:boolean=false;
    private _xbet1Tl:gsap.core.Timeline | undefined;

    constructor() {
        super();
        this._levelThresholds = BS2.model.initData.gameLevels.concat();
        this._maxThreshold = this._levelThresholds.reduce((accumulator: number, currentValue: number) => {
            return accumulator + currentValue;
        }, 0);
        this._currentLevel = 0;
        this._currentTotalValue = 0;
        this._currentLevelValue = 0;
        this.init();
        if(BS2.model.isRestore) {
            if(BS2.model.buyFeatureName===BS2Statics.BOOSTED_BET_1) {
                this._selectedBoostedBet=BS2Statics.BOOSTED_BET_1;
                this._wasXbet1Selected=true;
            }
            else if(BS2.model.buyFeatureName===BS2Statics.BOOSTED_BET_2){
                this._selectedBoostedBet=BS2Statics.BOOSTED_BET_2;
            }
        }
        BS2.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, () => {
            if (!BS2.model.isRestore) {
                this.handleXBetOnOffAnim();
            }
        })

    }

    public resetToZero(animated: boolean = false, isXBetSelected: boolean = false, animateLevelBarText: boolean = false,isCalledFromBet:boolean=false): void {
        if (this._currentScatterAddAnimation !== undefined && this._currentScatterAddAnimation.isActive()) {
            this._currentScatterAddAnimation.kill();
            this._currentScatterAddAnimation = undefined;
        }

        if (animated) {
            const tl: gsap.core.Timeline = gsap.timeline();
            for (let spineIdx: number = 0; spineIdx < this._sigillSpines.length; spineIdx++) {
                if (isXBetSelected && spineIdx === 0) {
                    continue;
                }
                tl.add(SpineGSAPWrapper.createTimeline(this._sigillSpines[spineIdx], 0, "", 0, 0, 0.25), 0);

            }
            tl.add(this._levelBar.fadeOutBarGraphic(0.25), 0);
            tl.add(() => {
                if (isXBetSelected) {
                    if (this._currentLevelValue > 0 || this._currentLevel > 0) {
                        this.setValue(20, false, false, animateLevelBarText).progress(1);
                    } else {
                        this.setValue(20, false, false, animateLevelBarText);
                    }
                } else {
                    this.setValue(0, false, false, animateLevelBarText,isCalledFromBet);
                }
            });
        } else {
            for (let spineIdx: number = 0; spineIdx < this._sigillSpines.length; spineIdx++) {
                if (isXBetSelected && spineIdx === 0) {
                    continue;
                }
                this._sigillSpines[spineIdx].state.setEmptyAnimation(0, 0);
            }
            this._levelBar.fadeOutBarGraphic(0);
            if (isXBetSelected) {
                if (this._currentLevelValue > 0 || this._currentLevel > 0) {
                    this.setValue(20, false, false, animateLevelBarText).progress(1);
                } else {
                    this.setValue(20, false, false, animateLevelBarText);
                }
            } else {
                this.setValue(0, false, false, animateLevelBarText);
            }
        }

    }

    public resetAllSigillSpines():void{
        for (let spineIdx: number = 0; spineIdx < this._sigillSpines.length; spineIdx++) {
            this._sigillSpines[spineIdx].state.setEmptyAnimation(0, 0);
        }
    }

    public setValue(totalValue: number, setSigillToUnlockState: boolean = false, isFeatureBuySfs: boolean = false, animateLevelBarText: boolean = false,isCalledFromBet:boolean=false,isRestore:boolean=false): gsap.core.Timeline {
        this._currentTotalValue = 0;
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(this.addToBar(totalValue, false, true, isFeatureBuySfs, animateLevelBarText,isCalledFromBet,isRestore));
        tl.add(() => {
            if (setSigillToUnlockState) {
                this.setLevel(this._currentLevel, true);
            } else {
                this.setLevel(this._currentLevel);
            }
        })
        return tl;
    }

    public playLevelUp(level: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        let shouldPlayWildOpeningSound:boolean=!BS2.model.isRestore;

        tl.add(()=>{
            BS2.soundPlayer.playSound(BS2Sound.RESPIN_ADD_WOOSH);
        },0);

        for (let i: number = 0; i < level; i++) {
            const trackEntry = this._sigillSpines[i].state.getCurrent(0);
            if (!trackEntry || trackEntry.animation.name !== "5_spent_loop") {
                const levelTl: gsap.core.Timeline = gsap.timeline();
                levelTl.add([SpineGSAPWrapper.createTimeline(this._sigillSpines[i], 0, "4_lvl_up"), BS2.reelView.bottomStickyWildView.unLockStickyWildTree(i,shouldPlayWildOpeningSound)]);
                shouldPlayWildOpeningSound = false;
                levelTl.add(() => {
                    SpineGSAPWrapper.createTimeline(this._sigillSpines[i], 0, "5_spent_loop", -1);
                });
                tl.add(levelTl, "<");
            }
        }
        return tl;
    }

    public addToBarWithTotalCollected(totalCollected: number): gsap.core.Timeline | undefined {
        const valueToAdd: number = totalCollected - this._currentTotalValue;
        if (valueToAdd > 0) {
            return this.addToBar(valueToAdd)
        }
        return undefined;
    }

    public addToBar(value: number, playSound: boolean = true, skipUnlock: boolean = false, featureBuySFS: boolean = false, animateLevelBarText: boolean = false,isCalledFromBet:boolean=false,isRestore:boolean=false): gsap.core.Timeline {
        const targetValues = this.calculateTargetValues(this._currentTotalValue + value),
            levelUpdates: number = targetValues.level - this._currentLevel,
            tl: gsap.core.Timeline = gsap.timeline(),
            duration: number = 0.30;
        let shouldPlayWildOpeningSound:boolean=!BS2.model.isRestore;
        for (let i: number = 0; i < levelUpdates; i++) {
            const level: number = this._currentLevel + i,
                levelMax: number = this._levelThresholds[level],
                sigiilAnim: gsap.core.Timeline = this.unlockLevel(level).pause();
            animateLevelBarText ? this.updateBarGraphics(levelMax, level, duration, playSound,isCalledFromBet,isRestore).progress(1) : tl.add(this.updateBarGraphics(levelMax, level, duration, playSound,isCalledFromBet,isRestore));
            tl.add(this.getLevelCountUp(levelMax, level, duration, animateLevelBarText), "<");
            if (!skipUnlock) {
                tl.add(this.unlockLevel(level).play(), "-=0.3");
            } else if (skipUnlock && featureBuySFS) {
                tl.add(() => {
                    BS2.soundPlayer.playSound(BS2Sound.LEVEL_UP_SHORT[level]);
                }, "-=0.3");
            }
            if (BS2.reelView.bottomStickyWildView.isLocked(level) && BS2.reelView.bottomStickyWildView.isVisible(level)) {
                if (BS2.model.data.wasFeatureBuy && BS2.model.data.mode===BS2GameMode.NORMAL && BS2.model.data.nextMode!==BS2GameMode.NORMAL) {
                    tl.add(BS2.reelView.bottomStickyWildView.removeStickyWild(level,shouldPlayWildOpeningSound, sigiilAnim.duration()), "<");
                    shouldPlayWildOpeningSound=false;
                } else {
                    // tl.add(BS2.reelView.bottomStickyWildView.unLockStickyWildTree(level, sigiilAnim.duration()), "<");
                }
            }
            this._currentLevelValue = levelMax;
        }

        if (targetValues.level < 5) {
            animateLevelBarText ? this.updateBarGraphics(targetValues.levelValue, targetValues.level, duration, playSound,isCalledFromBet,isRestore).progress(1) : tl.add(this.updateBarGraphics(targetValues.levelValue, targetValues.level, duration, playSound,isCalledFromBet,isRestore));
            tl.add(this.getLevelCountUp(targetValues.levelValue, targetValues.level, duration, animateLevelBarText), "<");
        }

        this._currentTotalValue = targetValues.totalValue;
        this._currentLevelValue = targetValues.levelValue;
        this._currentLevel = targetValues.level;

        return tl;
    }

    public addScatterToBar() {
        if (this._currentScatterAddAnimation != undefined && this._currentScatterAddAnimation.isActive()) {
            this._currentScatterAddAnimation.progress(1);
        }

        this._currentScatterAddAnimation = this.addToBar(10);
    }

    public show(duration: number = 0.2): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this._dynamicContainer, {duration: duration, alpha: 1, ease: "none"}));
        return tl;
    }

    public hide(durr: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(()=>{BS2.soundPlayer.playSound(BS2Sound.SFS_REMOVE_ROW)},0);
        tl.add(gsap.to(this._dynamicContainer, {duration: durr, alpha: 0, ease: "none"}), "<");
        return tl;
    }

    private handleXBetOnOffAnim(): void {
        const isXBet1Selected: boolean = BS2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === BS2Statics.BOOSTED_BET_1;
        const isXBet2Selected: boolean = BS2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === BS2Statics.BOOSTED_BET_2;

        if(BS2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === BS2Statics.BOOSTED_BET_1){
            this._wasXbet1Selected=true;
        }

        if(isXBet1Selected){
            this._selectedBoostedBet=BS2Statics.BOOSTED_BET_1;
        }
        else if(isXBet2Selected){
            this._selectedBoostedBet=BS2Statics.BOOSTED_BET_2;
        }
        if (isXBet1Selected) {
            if(this._xbet1Tl){
                this._xbet1Tl.kill();
                this._xbet1Tl=undefined;
            }
            this._currentTotalValue=0;
            this._xbet1Tl=gsap.timeline();
            this._xbet1Tl.add([this.addToBar(20, false, true, false, true,false),
            SpineGSAPWrapper.createTimelineForAnimation(this._sigillSpines[0],0,"5_spent_loop",true)
            ]);

        }
        else if(this._currentLevel!==0 && this._wasXbet1Selected){
            if(this._xbet1Tl){
                this._xbet1Tl.progress(1);
                this._xbet1Tl=undefined;
            }
            SpineGSAPWrapper.createTimeline(this._sigillSpines[0], 0, "", 0, 0,0.01);
            BS2.reelView.bottomStickyWildView.resetStickyWildFireAnimOnBet(0);
            this.setValue(0, false, false, true);
            this._wasXbet1Selected=false;
        }
        this.handleXBetSounds();
    }

    private handleXBetSounds() {
        if(this._selectedBoostedBet===BS2Statics.BOOSTED_BET_1 && BS2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === BS2Statics.BOOSTED_BET_1){
            BS2.soundPlayer.stopSfsIntroLoop();
            BS2.soundPlayer.stopXBet2Loop();
            BS2.soundPlayer.stopSound(BS2Sound.RITUAL_END);
            BS2.soundPlayer.stopSound(BS2Sound.SFS_INTRO_START);
            BS2.soundPlayer.stopSound(BS2Sound.SFS_OUTRO_END);
            BS2.soundPlayer.playSound(BS2Sound.RITUAL_START_1);
            BS2.soundPlayer.playLoopMusic(BS2Sound.RITUAL_LOOP_1);
            BS2.soundPlayer.fadeInLoopMusic(BS2Sound.RITUAL_LOOP_1,1);
        }
        else if(this._selectedBoostedBet===BS2Statics.BOOSTED_BET_2 && BS2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === BS2Statics.BOOSTED_BET_2){
            BS2.soundPlayer.stopSound(BS2Sound.RITUAL_END);
            BS2.soundPlayer.stopXBet1Loop();
            BS2.soundPlayer.fadeOutMusic();
            BS2.soundPlayer.stopSound(BS2Sound.SFS_OUTRO_END);
            BS2.soundPlayer.stopSound(BS2Sound.RITUAL_START_1);
            BS2.soundPlayer.playSound(BS2Sound.SFS_INTRO_START);
            BS2.soundPlayer.playLoopMusic(BS2Sound.SFS_INTRO_LOOP);
            BS2.soundPlayer.fadeInLoopMusic(BS2Sound.SFS_INTRO_LOOP,1);
            BS2.soundPlayer.playLoopMusic(BS2Sound.XBET2_LOOP);
            BS2.soundPlayer.fadeOutLoopMusic(BS2Sound.XBET2_LOOP);

        }
        else if(this._selectedBoostedBet===BS2Statics.BOOSTED_BET_1){
            BS2.soundPlayer.stopSfsIntroLoop();
            BS2.soundPlayer.stopXBet2Loop();
            BS2.soundPlayer.stopSound(BS2Sound.SFS_OUTRO_END);
            BS2.soundPlayer.stopXBet1Loop();
            BS2.soundPlayer.stopSound(BS2Sound.RITUAL_START_1);
            BS2.soundPlayer.stopSound(BS2Sound.SFS_INTRO_START);
            BS2.soundPlayer.playSound(BS2Sound.RITUAL_END);
            BS2.soundPlayer.switchMusic(BS2Sound.MAIN_GAME_MUSIC);
            BS2.soundPlayer.fadeInMusic(100,true);
            this._selectedBoostedBet=undefined;
        }
        else if(this._selectedBoostedBet===BS2Statics.BOOSTED_BET_2){
            BS2.soundPlayer.stopSfsIntroLoop();
            BS2.soundPlayer.stopXBet2Loop();
            BS2.soundPlayer.stopSound(BS2Sound.RITUAL_START_1);
            BS2.soundPlayer.stopXBet1Loop();
            BS2.soundPlayer.stopSound(BS2Sound.SFS_INTRO_START);
            BS2.soundPlayer.stopSound(BS2Sound.RITUAL_END);
            BS2.soundPlayer.playSound(BS2Sound.SFS_OUTRO_END);
            BS2.soundPlayer.switchMusic(BS2Sound.MAIN_GAME_MUSIC);
            BS2.soundPlayer.fadeInMusic(100,true);
            this._selectedBoostedBet=undefined;
        }
    }
    private init(): void {
        this._levelBar = new LevelBar(this._levelThresholds);
        this._sigillBarContainer = new PIXI.Container();
        this._sigillBarContainer.name = "SigillContainer";
        this._sigillBarContainer.position.set(326, 338);
        this._sigillSpines = [];
        for (let sigillIdx: number = 1; sigillIdx < 6; sigillIdx++) {
            let spine: PIXI.spine.Spine;
            if (sigillIdx === 1) {
                spine = new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.SIGILL_LVL_1));
                spine.position.x = 33;
            } else if (sigillIdx === 2) {
                spine = new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.SIGILL_LVL_2));
                spine.position.x = 33;
            } else if (sigillIdx === 3) {
                spine = new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.SIGILL_LVL_3));
                spine.position.x = 33;
            } else if (sigillIdx === 4) {
                spine = new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.SIGILL_LVL_4));
                spine.position.x = 33;
            } else {
                spine = new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.SIGILL_LVL_5));
                spine.position.x = 33;
            }
            spine.name = "sigill" + sigillIdx;
            this._sigillSpines.push(spine);
        }
        for (let spine of this._sigillSpines) {
            this._sigillBarContainer.addChild(spine);
        }

        this._dynamicContainer = new PIXI.Container();
        this._dynamicContainer.addChild(this._levelBar);
        this._dynamicContainer.addChild(this._sigillBarContainer);

        this.addChild(this._dynamicContainer);
    }

    private setLevel(level: number, setToUnlock: boolean = false): void {
        let anim: string = "5_spent_loop";
        if (setToUnlock) {
            anim = "3_waiting";
        }
        for (let i: number = 0; i < level; i++) {
            SpineGSAPWrapper.createTimeline(this._sigillSpines[i], 0, anim, -1);
        }
    }

    private getLevelCountUp(levelValue: number, level: number, duration: number, animateLevelBarText: boolean): gsap.core.Timeline {
        if (this._countUpAnim !== undefined && this._countUpAnim.isActive()) {
            this._countUpAnim.kill();
        }

        this._countUpAnim = this._levelBar.getCountUp(levelValue, level, duration, animateLevelBarText);

        return this._countUpAnim;
    }

    private updateBarGraphics(levelValue: number, level: number, duration: number, playSound: boolean,isCalledFromBet:boolean=false,isRestore:boolean=false): gsap.core.Timeline {
        const targetValue: number = (levelValue / this._levelThresholds[level]),
            tl: gsap.core.Timeline = gsap.timeline();

        if (levelValue < this._currentLevelValue) {
            tl.add(this._levelBar.reset(true, isCalledFromBet));
        }

        if (levelValue > 0) {
            tl.add(this._levelBar.animateTo(targetValue, duration,level,isRestore));
            if (playSound) {
                const targetIndex: number = Math.ceil(targetValue * BS2Sound.LEVEL_METER_UP.length) - 1;
                if (targetIndex >= 0) {
                    tl.add(() => {
                        BS2.soundPlayer.playSound(BS2Sound.LEVEL_METER_UP[targetIndex])
                    }, "<");
                }
            }

            tl.add(SpineGSAPWrapper.createTimeline(this._sigillSpines[level], 0, "1_add"), "<");
        }
        return tl;

    }

    private calculateTargetValues(totalValue: number) {
        if (totalValue >= this._maxThreshold) {
            totalValue = this._maxThreshold;
        }

        let localLevelValue: number = totalValue,
            localLevel: number = 0;
        for (let i: number = 0; i < this._levelThresholds.length; i++) {
            if (localLevelValue >= this._levelThresholds[i]) {
                localLevel++;
                if (localLevel >= this._levelThresholds.length) {
                    localLevel = this._levelThresholds.length;
                } else {
                    localLevelValue -= this._levelThresholds[i];
                }
            }
        }

        return {
            totalValue: totalValue,
            levelValue: localLevelValue,
            level: localLevel
        }
    }

    private playSigillAnimIfStateAnim(spine: PIXI.spine.Spine, animToPlay: string, conditionAnimName: string, loops: number): void {
        const currentTrack = spine.state.getCurrent(0)
        if (currentTrack && currentTrack.animation && currentTrack.animation.name == conditionAnimName) {
            SpineGSAPWrapper.createTimeline(spine, 0, animToPlay, loops);
        }
    }

    private unlockLevel(level: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            sigill: gsap.core.Timeline = gsap.timeline({paused: true});
        sigill.add(SpineGSAPWrapper.createTimeline(this._sigillSpines[level], 0, "2_unlock"));
        sigill.add(() => {
            this.playSigillAnimIfStateAnim(this._sigillSpines[level], "3_waiting", "2_unlock", -1)
        });
        tl.add(() => {
            sigill.play()
        }, "<");
        tl.add(() => {
            BS2.soundPlayer.playSound(BS2Sound.LEVEL_UP[level]);
            BS2.soundPlayer.playSound(BS2Sound.LEVEL_METER_SWOOSH.next());
        }, "<");
        if (level === 4) {
            tl.add(() => {
                if(!BS2.isWinBelowStake()){
                    BS2.soundPlayer.playSound(BS2Sound.RITUAL_END);
                }
            });
        }
        return tl;
    }

    get currentLevelValue(): number {
        return this._currentLevelValue;
    }


}